var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgX = function SvgX(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#X_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48.828,
    fill: "#000",
    rx: 24
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m25.95 22.81 7.63-8.869h-1.808l-6.625 7.701-5.292-7.7h-6.103l8.002 11.644-8.002 9.3h1.809l6.996-8.132 5.588 8.133h6.103zm-2.477 2.879-.81-1.16-6.451-9.227h2.777l5.206 7.447.81 1.16 6.767 9.678h-2.777z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "X_svg__a",
    width: 54.621,
    height: 55.448,
    x: -3.31,
    y: -3.31,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "BackgroundImageFix",
    stdDeviation: 1.655
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_2435_2071"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_backgroundBlur_2435_2071",
    result: "shape"
  })))));
};
export { SvgX as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDgiIGhlaWdodD0iNDkiIGZpbGw9Im5vbmUiPjxnIGZpbHRlcj0idXJsKCNhKSI+PHJlY3Qgd2lkdGg9IjQ4IiBoZWlnaHQ9IjQ4LjgyOCIgZmlsbD0iIzAwMCIgcng9IjI0Ii8+PHBhdGggZmlsbD0iI2ZmZiIgZD0ibTI1Ljk1IDIyLjgxIDcuNjMtOC44NjloLTEuODA4bC02LjYyNSA3LjcwMS01LjI5Mi03LjdoLTYuMTAzbDguMDAyIDExLjY0NC04LjAwMiA5LjNoMS44MDlsNi45OTYtOC4xMzIgNS41ODggOC4xMzNoNi4xMDNMMjUuOTQ5IDIyLjgxWm0tMi40NzcgMi44NzktLjgxLTEuMTYtNi40NTEtOS4yMjdoMi43NzdsNS4yMDYgNy40NDcuODEgMS4xNiA2Ljc2NyA5LjY3OGgtMi43NzdsLTUuNTIyLTcuODk4WiIvPjwvZz48ZGVmcz48ZmlsdGVyIGlkPSJhIiB3aWR0aD0iNTQuNjIxIiBoZWlnaHQ9IjU1LjQ0OCIgeD0iLTMuMzEiIHk9Ii0zLjMxIiBjb2xvci1pbnRlcnBvbGF0aW9uLWZpbHRlcnM9InNSR0IiIGZpbHRlclVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+PGZlRmxvb2QgZmxvb2Qtb3BhY2l0eT0iMCIgcmVzdWx0PSJCYWNrZ3JvdW5kSW1hZ2VGaXgiLz48ZmVHYXVzc2lhbkJsdXIgaW49IkJhY2tncm91bmRJbWFnZUZpeCIgc3RkRGV2aWF0aW9uPSIxLjY1NSIvPjxmZUNvbXBvc2l0ZSBpbjI9IlNvdXJjZUFscGhhIiBvcGVyYXRvcj0iaW4iIHJlc3VsdD0iZWZmZWN0MV9iYWNrZ3JvdW5kQmx1cl8yNDM1XzIwNzEiLz48ZmVCbGVuZCBpbj0iU291cmNlR3JhcGhpYyIgaW4yPSJlZmZlY3QxX2JhY2tncm91bmRCbHVyXzI0MzVfMjA3MSIgcmVzdWx0PSJzaGFwZSIvPjwvZmlsdGVyPjwvZGVmcz48L3N2Zz4=";